"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomInt = void 0;
/**
 * Generuje pseudolosową liczbę całkowitą z zakresu
 *
 * @export
 * @param {number} [min=0]
 * @param {number} [max=100]
 * @return {*}  {number}
 */
function randomInt(min = 0, max = 100) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
}
exports.randomInt = randomInt;
//# sourceMappingURL=randomInt.js.map